var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PaymentFormText } from "./PaymentForm-types";
export const processNewGiftCard = (getGiftCardByNumber, selectedGiftCard, setSelectedGiftCard, giftCards, setGiftCards, toast) => (giftCardNumber) => __awaiter(void 0, void 0, void 0, function* () {
    if (selectedGiftCard) {
        toast.push(PaymentFormText.ONE_GIFTCARD_ERROR, { variant: "error" });
        return;
    }
    getGiftCardByNumber(giftCardNumber).then((newGiftCard) => {
        if (!newGiftCard || newGiftCard.balance <= 0) {
            toast.push(PaymentFormText.GIFTCARD_NOT_FOUND, { variant: "error" });
            return;
        }
        const giftCardExists = giftCards === null || giftCards === void 0 ? void 0 : giftCards.find((gc) => gc.id === (newGiftCard === null || newGiftCard === void 0 ? void 0 : newGiftCard.id));
        if (!giftCardExists)
            setGiftCards((prev) => {
                if (prev)
                    return [...prev, newGiftCard];
                else
                    return [newGiftCard];
            });
        setSelectedGiftCard(newGiftCard);
        toast.push(PaymentFormText.GIFTCARD_ADDED, { variant: "success" });
    });
});
